import apiClient from './apiClient';

/**
 * Service for brand-related API calls
 */
const brandService = {
  /**
   * Get all brands
   * @returns {Promise<Object>} - Response data with brands
   */
  getAllBrands: async (params = {}) => {
    try {
      console.log('Fetching all brands');
      const response = await apiClient.get('/brands', { params });
      console.log('Brands API response:', response);
      
      return response.data || response;
    } catch (error) {
      console.error('Error getting brands:', error);
      throw error;
    }
  },
  
  /**
   * Get brand by ID
   * @param {string} brandId - Brand ID
   * @returns {Promise<Object>} - Brand data
   */
  getBrandById: async (brandId) => {
    try {
      console.log(`Fetching brand with ID: ${brandId}`);
      const response = await apiClient.get(`/brands/${brandId}`);
      console.log('Brand API response:', response);
      
      return response.data || response;
    } catch (error) {
      console.error(`Error getting brand ${brandId}:`, error);
      throw error;
    }
  },
  
  /**
   * Create a new brand
   * @param {Object} brandData - Brand data to create
   * @returns {Promise<Object>} - Response data
   */
  createBrand: async (brandData) => {
    try {
      console.log('Creating brand with data:', brandData);
      const response = await apiClient.post('/brands', brandData);
      console.log('Create brand response:', response);
      
      return response.data;
    } catch (error) {
      console.error('Error creating brand:', error);
      throw error;
    }
  },
  
  /**
   * Update an existing brand
   * @param {string} brandId - Brand ID
   * @param {Object} brandData - Brand data to update
   * @returns {Promise<Object>} - Response data
   */
  updateBrand: async (brandId, brandData) => {
    try {
      console.log(`Updating brand with ID: ${brandId}`, brandData);
      const response = await apiClient.put(`/brands/${brandId}`, brandData);
      console.log('Update brand response:', response);
      
      return response.data;
    } catch (error) {
      console.error(`Error updating brand ${brandId}:`, error);
      throw error;
    }
  },
  
  /**
   * Archive a brand through the recoverable DELETE compatibility alias
   * @param {string} brandId - Brand ID
   * @returns {Promise<Object>} - Response data
   */
  deleteBrand: async (brandId) => {
    try {
      console.log(`Archiving brand with ID: ${brandId}`);
      const response = await apiClient.delete(`/brands/${brandId}`);
      console.log('Archive brand response:', response);

      return response.data;
    } catch (error) {
      console.error(`Error archiving brand ${brandId}:`, error);
      throw error;
    }
  },

  uploadIcon: async (brandId, file) => {
    const formData = new FormData();
    formData.append('icon', file);
    const response = await apiClient.post(`/brands/${brandId}/icon`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

// Export as both default and named export to maintain compatibility
export { brandService };
export default brandService;
